import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IApiResponse,
  IMobileVerificationDto,
  IUserDto,
} from '../models';
import { CommonConstants } from 'src/app/shared/constant';
import { EncryptionService } from './encryption.service';

@Injectable()
export class UserService extends ApiService {
  private readonly mobileKey: string = CommonConstants.mobileKey;

  // private currentMobileSubject: BehaviorSubject<number[]>;
  // public currentMobile: Observable<number[]>;

  constructor(
    http: HttpClient,
    errorHandler: ErrorHandler,
    private readonly encryptionService: EncryptionService
  ) {
    super(http, errorHandler);
  }

  public setCurrentMobile(mobile: number[], isLongTerm: boolean): void {
    const json = this.encryptionService.setJson(mobile);

    if (isLongTerm) {
      localStorage.setItem(this.mobileKey, json);
    } else {
      sessionStorage.setItem(this.mobileKey, json);
    }
  }

  public getMobile(): number[] {
    let storedMobile: any = localStorage.getItem(this.mobileKey);

    if (storedMobile == null) {
      storedMobile = sessionStorage.getItem(this.mobileKey);
    }

    if (storedMobile == null) {
      return null;
    }

    const json = this.encryptionService.getJson(storedMobile);
    const client: number[] = json;

    return client;
  }

  public removeMobile(): void {
    localStorage.removeItem(this.mobileKey);
    sessionStorage.removeItem(this.mobileKey);
  }

  public getUser(): Observable<IApiResponse<IUserDto>> {
    return this.get(`user`);
  }

  public updateUser(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.put(`user`, model);
  }

  public validateOtp(
    model: IMobileVerificationDto
  ): Observable<IApiResponse<IMobileVerificationDto>> {
    return this.post(`user/verify`, model);
  }
}
